import { useCallback, useState } from "react";
import { useSaveDownloaded } from "../../../../../lib/hooks/useSaveDownloaded";
import ReportService from "../../../../../services/reportGeneration";

export const useExport = (form: any, closeModal: (value: boolean) => void) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { save } = useSaveDownloaded(
    "ConversationMessages.xlsx",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    setIsLoading,
  );

  const onExportClicked = useCallback(async () => {
    try {
      setIsLoading(true);

      const values = await form.validateFields();
      const res: any = await ReportService.exportByName(
        "ConversationMessages",
        values,
      );

      save(res);
      closeModal(false);
    } catch {
      setIsLoading(false);
    }
  }, [form, save, closeModal]);

  return { onExportClicked, isLoading };
};
